module.exports = __webpack_public_path__ + "static/media/branding-logo-topbar.0aedf985.png";